<div class="header">
  <div
    class="header-top"
    [class.header-top-full]="isVisibleDesc()"
  >
    <div
      class="header-info"
      [class.header-info-full]="isVisibleDesc()"
    >
      <div class="header-item">
        @for (field of productCardFields; track $index) {
          <div [matTooltip]="getTooltip(field.key)">
            <mat-form-field
              appearance="outline"
              class="none-pointer-events field"
            >
              <mat-label>{{ field.label }}</mat-label>
              <input
                matInput
                [(ngModel)]="productCardData()[field.key]"
              >
            </mat-form-field>
          </div>
        }
      </div>
      <div class="header-item">
        @for (btn of articleButtons; track $index) {
          <button
            mat-stroked-button
            color="primary"
            type="button"
            class="article-btn"
            [disabled]="isBtnDisabled(btn.key)"
            (click)="handleArticleMarketplace(btn.key)"
          >
            {{ btn.label }}
          </button>
        }
      </div>
    </div>
    @if (isVisibleDesc()) {
      <app-pc-rating
        [productCardId]="productCardId()"
        [productCardData]="productCardData()"
      />
    }
  </div>
  @if (isVisibleDesc()) {
    <div class="header-bottom">
      <app-pc-defects
        [productCardId]="productCardId()"
      />
      <div
        class="header-parameters"
        app-pc-parameters
        [productCardData]="productCardData()"
      ></div>
      <div>
        <button
          mat-stroked-button
          color="primary"
          class="article-btn"
          (click)="handleOpenSyncCompetitorArticle()"
        >
          Артикулы конкурентов
        </button>
      </div>
    </div>
  }
</div>
